import Proj1 from '../assets/images/proj1.jpg'
import Proj2 from '../assets/images/proj2.jpg'
import Proj3 from '../assets/images/proj3.webp'
import Proj4 from '../assets/images/proj4.webp'
import Proj5 from '../assets/images/proj5.jpg'
import Proj6 from '../assets/images/proj6.png'


export const ProjectList = [
    {
        name: "Dijkstra Algorithm Visualizer",
        image: Proj1,
        skills: ["JavaScript", "HTML", "CSS"].join(', ')
    },
    {
        name: "E-Commerce website",
        image: Proj2,
        skills: ["NodeJS", "MongoDB", "Axios"].join(', ')
    },
    {
        name: "Spotify Clone",
        image: Proj3,
        skills: ["GraphQL", "MongoDB", "ElectronJS"].join(', ')
    },
    {
        name: "Social Media Website",
        image: Proj4,
        skills: ["HTML", "TailwindCSS", "ReactJS"].join(', ')
    },
    {
        name: "Dashboard Visualizer",
        image: Proj5,
        skills: ["TypeScript", "ElectronJS", "JQuery"].join(', ')
    },
    {
        name: "Mobile Game",
        image: Proj6,
        skills: ["C#", "C++", "Blender3D", "Graphical Programming"].join(', ')
    }
]